import { useMemo } from 'react';
import { useMMGRSettings } from '../hoc/withMMGRSettings';
import { parseSiteMediaToken } from '../siteMediaToken';

export const useParsedSiteMediaToken = () => {
  const {
    mmgrSettings: { siteMediaToken },
  } = useMMGRSettings();

  return useMemo(() => parseSiteMediaToken(siteMediaToken), [siteMediaToken]);
};
